<script lang="ts">
	import { DotSize, DotType } from "../Dot";

	export let size: DotSize;
	export let type: DotType;
</script>

<span
	class="inline-flex items-center rounded-full
		{size === DotSize.Xs ? 'h-2 w-2' : ''}
		{size === DotSize.Sm ? 'h-3 w-3' : ''}
		{size === DotSize.Md ? 'h-4 w-4' : ''}
		{type === DotType.Success ? 'bg-tertiary' : ''}
		{type === DotType.Info ? 'bg-blue' : ''}
		{type === DotType.Error ? 'bg-primary' : ''}
	"
>
	&nbsp;
</span>
